module.exports = __webpack_public_path__ + "static/media/zelinskyCollectionDvd02.72e47ffd.jpg";